const topicTags = [
  { name: '明星塌房', count: 328, hot: true },
  { name: '51吃瓜同步', count: 291, hot: true },
  { name: '17c黑料', count: 256, hot: true },
  { name: '综艺翻车现场', count: 214, hot: false },
  { name: '网红黑历史', count: 198, hot: false },
  { name: '剧组内幕', count: 183, hot: false },
  { name: '明星婚姻吃瓜', count: 167, hot: true },
  { name: '代言翻车', count: 145, hot: false },
  { name: '选秀黑幕', count: 128, hot: false },
  { name: '娱圈税务风波', count: 112, hot: false },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">热门话题</h2>
          <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full font-semibold whitespace-nowrap">10大标签</span>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 pl-4">吃瓜群众最关注的话题标签，娱乐圈八卦与明星黑料分类直达</p>

        <div className="flex flex-wrap gap-3">
          {topicTags.map((tag, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full transition-all cursor-pointer whitespace-nowrap ${
                tag.hot
                  ? 'bg-primary-100 hover:bg-primary-200 text-primary-800 border border-primary-200'
                  : 'bg-background-100 hover:bg-background-200 text-foreground-700 border border-background-200'
              }`}
            >
              <span className="text-sm font-semibold">{tag.name}</span>
              <span
                className={`text-xs px-1.5 py-0.5 rounded-full ${
                  tag.hot ? 'bg-primary-200 text-primary-700' : 'bg-background-200 text-foreground-500'
                }`}
              >
                {tag.count}
              </span>
              {tag.hot && <i className="ri-fire-line text-xs text-primary-500"></i>}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}